var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Emitter from '../utils/emitter';
import errorFormat from '../utils/error-format';
import { decorator } from '../utils/instance';
import log from '../utils/log';
import transApproach from '../utils/cookie-utils';
var domainRegx = /^([^.]+)\.([^.]+)\.(.*?)$/i;
function formatParams(params) {
    var e_1, _a;
    if (!params) {
        return '';
    }
    var pairs = [];
    try {
        for (var _b = __values(Object.getOwnPropertyNames(params)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = params[key];
            if (value != null && value != undefined) {
                pairs.push(key + "=" + encodeURIComponent(value));
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return pairs.join('&');
}
function _process(data) {
    if (typeof data === 'object') {
        data = JSON.stringify(data);
    }
    if (typeof data === 'string') {
        return data.replace(/([\ud835-\ud83f][\u0000-\uffff])/g, function ($) {
            return '\\u' + $.charCodeAt(0).toString(16) + '\\u' + $.charCodeAt(1).toString(16);
        });
    }
    else {
        return data;
    }
}
var API = (function (_super) {
    __extends(API, _super);
    function API(config) {
        var _this = _super.call(this) || this;
        _this.config = config;
        if (_this.config.mtop) {
            _this._mtop = _this.config.mtop;
        }
        else if (window.lib && window.lib.mtop) {
            _this._mtop = window.lib.mtop;
        }
        else {
            throw new Error('window.lib.mtop must be required!');
        }
        if (config.mtopDomain) {
            var _a = __read(domainRegx.exec(config.mtopDomain), 4), prefix = _a[1], subDomain = _a[2], mainDomain = _a[3];
            _this._mtop.config.prefix = prefix;
            _this._mtop.config.subDomain = subDomain;
            _this._mtop.config.mainDomain = mainDomain;
            if (window.lib && window.lib.mtop) {
                window.lib.mtop.config.prefix = prefix;
                window.lib.mtop.config.subDomain = subDomain;
                window.lib.mtop.config.mainDomain = mainDomain;
            }
        }
        return _this;
    }
    API.prototype.mtop = function (api, data, opt) {
        var _a;
        if (opt === void 0) { opt = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var config, params, resp, resp_1, err;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!api)
                            throw new Error('mtop api name must be defined!');
                        config = this.config;
                        if (data && data.umidToken !== undefined) {
                            opt.headers = (_a = opt.headers) !== null && _a !== void 0 ? _a : {};
                            opt.headers['x-umt'] = data.umidToken;
                        }
                        params = Object.assign({
                            api: api,
                            v: '1.0',
                            H5Request: true,
                            syncCookieMode: true,
                            appKey: config.appKey,
                            'x-i18n-language': transApproach(config.lang || 'en_US', {
                                "connector": "underline",
                                "region": "uppercase"
                            }),
                            'x-i18n-regionID': config.region,
                            data: data,
                        }, opt);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        params.data = _process(params.data);
                        return [4, this._mtop.request(params)];
                    case 2:
                        resp = _b.sent();
                        return [2, Promise.resolve(resp === null || resp === void 0 ? void 0 : resp.data)];
                    case 3:
                        resp_1 = _b.sent();
                        err = void 0;
                        if (resp_1.retType === 2) {
                            err = errorFormat('USER_NOT_LOGIN', '用户未登录');
                            this.emit('sessionTimeout');
                            return [2, Promise.resolve(resp_1)];
                        }
                        else if (resp_1.retType === 1) {
                            err = errorFormat('TOKEN_EXPIRED', 'mtop请求token过期');
                            this.emit('sessionTimeout');
                            return [2, Promise.resolve(resp_1)];
                        }
                        else {
                            err = errorFormat(resp_1.ret[0] ? resp_1.ret[0] : resp_1, null, { param: data, api: resp_1.api || api });
                        }
                        log({
                            key: '/lzdsellerapp.IM_PC.im-error',
                            config: config,
                            data: {
                                api: api,
                                type: JSON.stringify(resp_1.ret[0]),
                            }
                        });
                        return [2, Promise.reject(__assign({ api: api, type: 'error' }, err))];
                    case 4: return [2];
                }
            });
        });
    };
    API.prototype.ajax = function (api, data, opt) {
        if (opt === void 0) { opt = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        var params = formatParams(data);
                        var url = "" + api + (params !== '' ? "?" + params : '');
                        var method = 'GET';
                        var xhr = new XMLHttpRequest();
                        xhr.onreadystatechange = function () {
                            if (xhr.readyState === 4) {
                                if (xhr.status === 200) {
                                    var resp = JSON.parse(xhr.responseText);
                                    resolve(resp.model);
                                }
                                else {
                                    reject(new Error(xhr.status + " [" + method + "]: " + url));
                                }
                            }
                        };
                        xhr.open(method, url);
                        xhr.send();
                    })];
            });
        });
    };
    API.prototype.request = function (api, data, opt) {
        if (opt === void 0) { opt = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var useMtop;
            return __generator(this, function (_a) {
                if (typeof api === 'function') {
                    return [2, api(data, opt)];
                }
                useMtop = window._im_use_mtop;
                if (api.startsWith('mtop.') || useMtop) {
                    return [2, this.mtop(api, data, opt)];
                }
                else {
                    return [2, this.ajax(api, data, opt)];
                }
                return [2];
            });
        });
    };
    API = __decorate([
        decorator
    ], API);
    return API;
}(Emitter));
export default API;
